import React, { useContext, useState } from 'react'
import { motion } from 'framer-motion'

/*COMPONENTS */
import Header from '../../components/Header'
import TableList from '../../components/TableListProducts'
import SidebarEl from '../../components/SidebarEl'
import Filter from '../../components/Filter'
import ModalProduct from '../../components/ModalProduct'
import ModalEditProduct from '../../components/ModalEditProduct'
import ModalConfirmTrash from '../../components/ModalConfirmTrash'

import styled from 'styled-components'
import DashboardGrafical from '../../components/DashboardGrafical'
import MobileMenu from '../../components/MobileMenu'
import animation from '../../images/animated/Animation - 1736914973262.json'
import { ProductsContext } from '../../context/products'
import Lottie from 'react-lottie';
import { ToastContainer } from 'react-toastify'

const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }



    

    @media screen and (max-width:720px){
        .colum_primary{ 
        flex:0;
    }

        .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }
    }

`
const RowDashboard = styled.div`

    display: flex;
    justify-content:space-between; 
    align-items: center;

    @media screen and (max-width:720px){

        flex-direction: column;
        
    }

`
const CardAnimation = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: white;

    p{
        margin-top: 1.9rem;
        font-family: "Poppins";
        text-align: center;
        height: 19px;
        font-size: 1.4rem;
    }
    

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const Products = () => {
    const { get, dashboard, animationInsertProduct,editModalShow,setEditModalShow,showModalConfirm,setShowModalConfirm,btnAnimation} = useContext(ProductsContext)
    const [modalShow, setModalShow] = React.useState(false);

    const [structure] = useState([

        {
            name: "Imagem",
        },
        {
            name: "Produto",
        },

        {
            name: "Preço Original",
        },

        {
            name: "Categoria",
        },

        {
            name: "SubCategoria",
        },

        {
            name: "Status",
        },

        {

            name:"Excluir"

        },



    ])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }


    function MyVerticallyCenteredModal(props) {
        return (
            <ModalProduct props={props} />
        );
    }
    function ModalEditProductEl(props) {
        return (
            <ModalEditProduct props={props} />
        );
    }
    function ModalConfirmTrashEl(props) {
        return (
            <ModalConfirmTrash props={props} />
        );
    }

    return (

        animationInsertProduct == true

            ?
            <CardAnimation>
                <div style={{ margin: "0 auto" }}>
                    <Lottie options={defaultOptions}
                        height={400}
                        width={400}
                    />
                    <p>Processando seu pedido.</p>
                    <p>Por favor aguarde.</p>
                </div>
            </CardAnimation>
            :

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <CardWrapper>
                    <ToastContainer/>

                    <div className='colum_primary'>
                        <SidebarEl />
                    </div>

                    <FixWidthSidebar/>

                    <div className='colum_secondary'>
                        <Header name="Meus Produtos" />
                        <Filter buttonName={"Adicionar"} onChange={(e) => get(e.target.value)} animation={btnAnimation} type={1} onClick={() => setModalShow(true)} />
                        <RowDashboard>
                            <DashboardGrafical type={1} backgroundColor={""} value={dashboard?.total} name="Total de Produtos" />
                            <DashboardGrafical type={2} backgroundColor={""} value={dashboard?.productsWithoutStock} name="Total Sem Estoque" />
                            <DashboardGrafical type={3} backgroundColor={""} value={dashboard?.withoutDatasheet} name="Total Sem Ficha" />

                        </RowDashboard>
                        <TableList structure={structure} />

                        <MyVerticallyCenteredModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                        />

                        <ModalEditProductEl
                            show={editModalShow}
                            onHide={() => setEditModalShow(false)}
                        />

                        <ModalConfirmTrashEl
                            show={showModalConfirm}
                            onHide={() => setShowModalConfirm(false)}

                        />
                    </div>

                </CardWrapper>
                <MobileMenu />
            </motion.div>
    )
}

export default Products